import { render, staticRenderFns } from "./RequestComponent.vue?vue&type=template&id=7917a139&lang=pug&"
import script from "./RequestComponent.vue?vue&type=script&lang=js&"
export * from "./RequestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports